import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:apps.summit',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_1',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_2',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_3',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_4',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_5',
  ],
  description: 'Summit pre-filled with demo data from GMU',
  name: 'Summit (GMU Demo)',
} as const satisfies core.quiver.Package
